// GET EOL Option Api
export const geteolOptionApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/eol_options${queryString ? `?${queryString}` : ""}`;
};

// POST EOL Option Api
export const addEolApi = (params) => {
    return `lease/${params?.leaseSlug}/eol_options`;
};

// PUT edit EOL Option Api
export const updateEolApi = (params) => {
    return `lease/${params?.leaseSlug}/eol_options/${params?.slug}`;
};

// DELETE EOL Option Api
export const deleteEolApi = (params) => {
    return `lease/${params?.leaseSlug}/eol_options`;
};
// Constant Post api
export const leaseOptionTypeApi = () => {
    return `/lease/constants/get_by_constant_types`;
};


export const eolfileUploadApi = (eol_options_slug) => {
    return `/get-pre-signed-url/eol_options/${eol_options_slug}`;
};

export const eolAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/eol_options/${attachments_slug}`
}
